// eslint-disable-next-line import/prefer-default-export
export const GET_WORKSHOP_TYPES = 'GET_WORKSHOP_TYPES';
